var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronDown = function SvgChevronDown(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Chevron Down",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-933.000000, -230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chevron-down---outlined",
    transform: "translate(933.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.64644661,6.64644661 C3.82001296,6.47288026 4.08943736,6.45359511 4.2843055,6.58859116 L4.35355339,6.64644661 L8,10.293 L11.6464466,6.64644661 C11.820013,6.47288026 12.0894374,6.45359511 12.2843055,6.58859116 L12.3535534,6.64644661 C12.5271197,6.82001296 12.5464049,7.08943736 12.4114088,7.2843055 L12.3535534,7.35355339 L8.35355339,11.3535534 C8.17998704,11.5271197 7.91056264,11.5464049 7.7156945,11.4114088 L7.64644661,11.3535534 L3.64644661,7.35355339 C3.45118446,7.15829124 3.45118446,6.84170876 3.64644661,6.64644661 Z",
    id: "Icons/16/Chevron-down"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chevron-down.bbe4a45003cfc4157abedc911a00c9a7.svg";